import axios from 'axios';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import { UnitOfMeasureModel } from 'src/models/services/unitOfMeasure';

const API_Controller = '/UnitOfMeasures';

export const UnitOfMeasuresService = {
  getAllData: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data as UnitOfMeasureModel[];
    } catch (error) {
      throw error;
    }
  },

  addData: async (dataToAdd: UnitOfMeasureModel) => {
    const reModel = {
      ShortName: dataToAdd.shortName,
      Description: dataToAdd.description,
      Status: dataToAdd.status
    };
    try {
      const response = await axios.post(`${API_url}${API_Controller}`, reModel);
      enqueueSnackbar(`Units of measure Added Successfully`, {
        variant: 'success'
      });
      return response.data as UnitOfMeasureModel[];
    } catch (error) {
      enqueueSnackbar(`Units of measure Add unsuccessful`, {
        variant: 'error'
      });
      throw error;
    }
  },

  editData: async (dataToUpdate: UnitOfMeasureModel) => {
    const reModel = {
      Id: dataToUpdate.id,
      ShortName: dataToUpdate.shortName,
      Description: dataToUpdate.description,
      Status: dataToUpdate.status
    };
    try {
      const respons = await axios.put(
        `${API_url}${API_Controller}/update`,
        reModel
      );
      enqueueSnackbar(`Units of measure edited Successfully`, {
        variant: 'success'
      });
      return respons.data as UnitOfMeasureModel[];
    } catch (error) {
      enqueueSnackbar(`Units of measure edite unsuccessful`, {
        variant: 'error'
      });
      throw error;
    }
  },

  deleteData: async (deleteId, data) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${deleteId}`
      );
      enqueueSnackbar(`Units of measure deleted Successfully`, {
        variant: 'success'
      });
      return response.data as UnitOfMeasureModel[];
    } catch (error) {
      enqueueSnackbar(
        `Units of measure delete unsuccessfully. Assign to service`,
        {
          variant: 'error'
        }
      );
      throw error;
    }
  }
};
